let itemsInCart = 0;

function unataCartHandlers() {
	const orderOnline = document.querySelector('#order-button');
	const cartFrame = document.querySelector('#instacart-cart');
	//default logic in case anything fails, show the cart widget
	if (!cartFrame || !orderOnline) {
		return;
	}
	cartFrame.style.display = 'block';
	orderOnline.style.display = 'none';
	if (cartFrame && screen.width > 681) {
		// if (orderOnline) { orderOnline.style.display = 'none'; }
		if (itemsInCart > 0) {
			cartFrame.style.display = 'block';
			orderOnline.style.display = 'none';
		} else {
			cartFrame.style.display = 'none';
			orderOnline.style.display = 'block';
		}
	}


}
/**
 * Public API for Instacart Widget, this allows us to know when the cart is 
 * updated (i.e number of items changes in the cart)
 * eventData: Object contains details property which contains totalUniqueItems (number)
 */
document.addEventListener('ic-cart-change', function (eventData) {
	if (eventData && eventData.details && eventData.details.totalUniqueItems) {
		itemsInCart = eventData.details.totalUniqueItems;
	}
	unataCartHandlers();
});
window.addEventListener('resize', function () {
	unataCartHandlers();
});
unataCartHandlers();